var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49946 2C3.49946 1.72386 3.72332 1.5 3.99946 1.5L7.99946 1.5V4.5C7.99946 5.32843 8.67103 6 9.49946 6L12.4995 6V13C12.4995 13.2761 12.2756 13.5 11.9995 13.5H3.99946C3.72332 13.5 3.49946 13.2761 3.49946 13V2ZM9.49946 4V1.5L12.4995 4.5L9.99946 4.5C9.72332 4.5 9.49946 4.27614 9.49946 4ZM3.5 0C2.67156 0 1.99999 0.671587 2 1.50002L2.00019 13.5C2.00021 14.3284 2.67178 15 3.50019 15H12.4995C13.3279 15 13.9995 14.3284 13.9995 13.5L13.9995 4.62132C13.9995 4.2235 13.8414 3.84196 13.5601 3.56066L10.4388 0.43934C10.1575 0.158035 9.77597 0 9.37814 0H3.5ZM5.74998 7.5C5.33576 7.5 4.99998 7.83579 4.99998 8.25C4.99998 8.66421 5.33576 9 5.74998 9H10.25C10.6642 9 11 8.66421 11 8.25C11 7.83579 10.6642 7.5 10.25 7.5H5.74998ZM5.74998 10.5C5.33576 10.5 4.99998 10.8358 4.99998 11.25C4.99998 11.6642 5.33576 12 5.74998 12H10.25C10.6642 12 11 11.6642 11 11.25C11 10.8358 10.6642 10.5 10.25 10.5H5.74998Z",
    fill: "#009866"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.359190ed098e9409f494af2046609b02.svg";
export { ForwardRef as ReactComponent };